import React from 'react';

export default function TeamIntro() {
  return (
    <section className="w-full bg-gray-950 text-white py-20 px-6 md:px-10">
      <div className="max-w-5xl mx-auto space-y-14">

        {/* Section Header */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Meet the Team</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            M2T is founder-led with global experience in trading, tech, and platform development — backed by advisors and a clear hiring roadmap.
          </p>
        </div>

        {/* Founder */}
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 bg-gray-900 border border-gray-700 p-6 rounded-xl shadow">
          <div className="flex-shrink-0 w-24 h-24 rounded-full bg-purple-600 text-white flex items-center justify-center text-2xl font-bold">
            SK
          </div>
          <div>
            <h3 className="text-xl font-semibold">Senthil Kumar (Mr. Senthee)</h3>
            <p className="text-gray-400 text-sm mb-2">Founder & CEO</p>
            <p className="text-gray-300 text-sm">
              13+ years in trading, automation, product design, and global platform execution — spanning India, UAE, and Africa. Currently Head of R&D in Tanzania’s top auto firm. Full-stack builder, strategist, and operator.
            </p>
          </div>
        </div>

        {/* Advisors */}
        <div className="space-y-6">
          <h4 className="text-2xl font-semibold text-white">Advisors & Strategic Roles</h4>
          <ul className="text-sm text-gray-300 list-disc list-inside space-y-2">
            <li>
              <strong>A.G. Sivakumar</strong> – Strategy Advisor (10% equity). 25+ years in finance, global operations, and investment consulting.
            </li>
            <li>
              <strong>Mageswari S. Kumar</strong> – Regulatory/Market Access Advisor. Ex-insurance and healthcare analyst with global reach.
            </li>
            <li>
              <strong>Rashmitha Kumar</strong> – Gen-Z User Advisor. Student, researcher, and content test pilot for M2T’s education vertical.
            </li>
          </ul>
        </div>

        {/* Future Hiring */}
        <div className="space-y-4 pt-8">
          <h4 className="text-2xl font-semibold text-white">Future Hires (Post-Seed)</h4>
          <ul className="text-sm text-gray-300 list-disc list-inside space-y-2">
            <li>Founding CTO (React, Firebase, TypeScript, AI tools)</li>
            <li>Community & Growth Manager (early role onboarding + partnerships)</li>
            <li>Compliance Consultant (GDPR, SEBI, licensing)</li>
            <li>UI/UX Lead for dashboard, mobile, and onboarding systems</li>
          </ul>
        </div>

      </div>
    </section>
  );
}
